module.exports = (content = {}, userAuth, optimisitic = true) => {
    if (Object.keys(content).length > 0) {
        if (content.type === 'video' || content.sourceId === 'SHORTSTOPLIVE') {
            return true;
        }

        if (userAuth && content.authTypes) {
            return (content.authTypes.some(authType => userAuth.indexOf(authType) !== -1 ||
                (userAuth.indexOf(`unknown_${authType}`) !== -1 && optimisitic)));
        }
        return false;
    }
    return (optimisitic && true);
};



// WEBPACK FOOTER //
// ./app/lib/auth/shallowCheckAuthentication.js